// extracted by mini-css-extract-plugin
export var actions = "_1p-0";
export var actionsContainer = "_1p-7";
export var border = "_1p-1";
export var childFullHeight = "_1p-f";
export var collapse = "_1p-2";
export var content = "_1p-a";
export var contentChild = "_1p-e";
export var fullscreen = "_1p-c";
export var hasLeftRadius = "_1p-k";
export var headerContainer = "_1p-3";
export var headerRow = "_1p-5";
export var hidePadding = "_1p-b";
export var navCollapsedGap = "_1p-l";
export var noScrollX = "_1p-m";
export var noScrollY = "_1p-n";
export var noTopPadding = "_1p-i";
export var optOutTopPadding = "_1p-d";
export var pageMain = "_1p-j";
export var pageOuter = "_1p-g";
export var pagePadding = "_1p-8";
export var pageScroll = "_1p-9";
export var profile = "_1p-o";
export var profileContainer = "_1p-p";
export var profileImage = "_1p-q";
export var profileMain = "_1p-r";
export var profileSubtitle = "_1p-t";
export var profileTitle = "_1p-s";
export var showLeftPadding = "_1p-h";
export var tabsPortalSlot = "_1p-6";
export var tabsWrapper = "_1p-4";
export var title = "_1p-u";